"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecificScheduleURI = exports.frontPageScheduleURI = void 0;
exports.frontPageScheduleURI = `https://plain.kvg.bonk.lt/mfw3.html`;
const getSpecificScheduleURI = (href) => !href ? "" : `https://plain.kvg.bonk.lt/${href}`;
exports.getSpecificScheduleURI = getSpecificScheduleURI;
//# sourceMappingURL=Schedule.js.map